export * from "../overrides/video";

// soon to be depricated.
import { Video } from "../overrides/video";

export default Video
